import { create, type StateCreator } from 'zustand';
import { persist, type PersistOptions } from 'zustand/middleware';
import { appConfigs } from '@/common/configs/app.config';

export interface AuthStore {
  mobile: string;
  loginToken: string;
  otpExpiresIn: number;
  timestamp: number;
  setMobile: (mobile: string) => void;
  resetOtpExpiresIn: () => void;
  setLoginToken: (loginToken: string) => void;
  reset: () => void;
}

type AuthPersist = (
  config: StateCreator<AuthStore>,
  options: PersistOptions<AuthStore>
) => StateCreator<AuthStore>;

export const useAuthStore = create<AuthStore, []>(
  (persist as AuthPersist)(
    (set): AuthStore => ({
      mobile: '',
      loginToken: '',
      otpExpiresIn: Date.now(),
      timestamp: Date.now(),
      setLoginToken: (loginToken) => {
        set(() => ({
          loginToken,
          otpExpiresIn: Date.now() + appConfigs.otpExpiresIn,
        }));
      },
      resetOtpExpiresIn: () => {
        set(() => ({ otpExpiresIn: Date.now() + appConfigs.otpExpiresIn }));
      },
      setMobile: (mobile) => {
        set(() => ({ mobile }));
      },
      reset: () => {
        set(() => ({ mobile: '', loginToken: '' }));
      },
    }),
    {
      name: 'auth',
    }
  )
);

export const selectMobile = (state: AuthStore) => state.mobile;
export const selectLoginToken = (state: AuthStore) => state.loginToken;
export const selectOTPExpiresIn = (state: AuthStore) => state.otpExpiresIn;
export const selectSetMobile = (state: AuthStore) => state.setMobile;
export const selectSetLoginToken = (state: AuthStore) => state.setLoginToken;
export const selectResetLogin = (state: AuthStore) => state.reset;
